export const attributes = {
    time_range_error_message: "End time must be after the start time",
    attribute_list_items: "attribute list items",
    attribute_list_item: "attribute list item",
    attribute_list_item_order: "attribute list item order",
} as const;
